import { Component, OnInit } from '@angular/core';
import { SplashScreenService } from '../../services/splash-screen.service';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit {
  showSplash: boolean = true;

  constructor() {}

  private hideSplashAnimation() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.showSplash = false;
    }, 4500);
  }
}
